import { UserEventStatsDto } from '@shared/core/events'
import ms from 'ms'
import { useQuery, UseQueryOptions } from 'react-query'
import { useHandleRetry } from 'src/modules/core/hooks/use-handle-retry'
import { ApiService } from 'src/services/api.service'

export const GET_USER_EVENT_STATS_CACHE_KEY = 'get-user-event-stats'

export function useUserEventStats(options?: UseQueryOptions<UserEventStatsDto>) {
  const handleRetry = useHandleRetry()

  return useQuery(GET_USER_EVENT_STATS_CACHE_KEY, () => ApiService.Events.getUserEventStats(), {
    staleTime: ms('5m'),
    retry: handleRetry,
    ...options,
  })
}
